module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/monitor-pc/black.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/monitor-pc/black.jpg
// module id = 594
// module chunks = 0